import React from "react";
import AppleStore from "../atomic/Vectors/AppleStore";
import PlayStore from "../atomic/Vectors/PlayStore";
import Image from "next/image";
import Link from "next/link";

function MobileCard() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="border border-gray-200 bg-transparent px-6 py-12 md:py-0 md:pl-14 md:pr-0 flex flex-col-reverse md:flex-row items-center gap-8 md:gap-0 rounded-3xl">
      {/* Left Content */}
      <section className="flex-1 md:py-16">
        <div className="flex flex-col items-center md:items-start">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-3">
            Mobile App
          </span>

          <h4 className="text-gray-900 text-3xl md:text-4xl text-center md:text-left font-black tracking-tight leading-tight">
            Now learning at the{" "}
            <span className="text-primary">tip of your finger</span>
          </h4>

          <p className="text-gray-500 mt-5 text-center md:text-left text-base leading-relaxed max-w-sm">
            An easier and faster way to prepare for your examinations. Get
            started with the Clamphook mobile application.
          </p>

          <div className="flex flex-wrap justify-center md:justify-start items-center mt-8 gap-4">
            <Link
              href="https://apps.apple.com/us/app/clamphook-academy/id6737482974"
              target="_blank"
            >
              <div className="h-12 cursor-pointer hover:opacity-80 transition-opacity">
                <AppleStore />
              </div>
            </Link>

            <Link
              href="https://play.google.com/store/apps/details?id=com.clamphook.clamphook"
              target="_blank"
            >
              <div className="h-12 cursor-pointer hover:opacity-80 transition-opacity">
                <PlayStore />
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Right Image */}
      <section className="flex-1 flex justify-center items-center py-12 md:py-16">
        <div
          className="relative w-[200px] md:w-[240px] aspect-[9/19]
            border-[8px] border-gray-900 rounded-[2rem] bg-gray-900
            shadow-[12px_24px_40px_rgba(0,0,0,0.15)]
            rotate-[-6deg] sm:rotate-[-8deg]
            hover:rotate-0 hover:scale-105 transition-all duration-500 ease-out"
        >
          {/* Hardware Buttons */}
          <div className="absolute -left-[11px] top-16 w-[3px] h-6 bg-gray-900 rounded-l-sm" />
          <div className="absolute -left-[11px] top-28 w-[3px] h-12 bg-gray-900 rounded-l-sm" />
          <div className="absolute -left-[11px] top-44 w-[3px] h-12 bg-gray-900 rounded-l-sm" />
          <div className="absolute -right-[11px] top-36 w-[3px] h-16 bg-gray-900 rounded-r-sm" />

          {/* Screen Content */}
          <div className="relative w-full h-full overflow-hidden rounded-[1.5rem] bg-white">
            <Image
              src="/img/clamphook_app.png"
              alt="Clamphook Mobile App"
              fill
              sizes="(max-width: 768px) 200px, 240px"
              className="object-contain"
              loading="lazy"
            />
          </div>
        </div>
      </section>
      </div>
    </div>
  );
}

export default MobileCard;
